export default "__VITE_ASSET__0PK$8mM0__"